/* eslint-disable */ import { entities as v1 } from './versions/v1.js';
import { entities as v2 } from './versions/v2.js';
import { entities as v3 } from './versions/v3.js';
import { entities as v4 } from './versions/v4.js';
export * from './versions/v4.js';
export const modelVersions = {
    1: v1,
    2: v2,
    3: v3,
    4: v4
};

//# sourceMappingURL=index.js.map